import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import BoxSections from './BoxSections'
import ContentDiv from './ContentDiv'
import HeroSections from './HeroSections'
import KeyFeature from './KeyFeature'
import { Helmet } from 'react-helmet'
export default function DesignPageIndex(props) {
    const { nft_slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [nft_slug])
    // =========================== scroll To Top default =========================
    return (
        <>
              <Helmet>
                <title>Web Design Services – Infograins</title>
                <meta name="description" content="Infograins is a top website design agency that provides innovative and responsive web design services. " />
            </Helmet>
            <HeroSections />
            <BoxSections />
            <ContentDiv />
        </>
    )
}
